import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CardHeader from "@commons/businesscardHeader";
import Column from "@components/column";
import Fields from "@components/fields";
import Row from "@components/row";
import Wrapper from "@components/wrapper";
import Button from "@components/button";
import { toast } from "react-toastify";
import { GeneralSetting } from "@apis/index";

const Bank = () => {
  const [initialValues, setInitialValues] = useState({
    bankName: "",
    accountName: "",
    accountNumber: "",
    bankQr: null,
  });

  const [existing, setExisting] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchBankSettings = async () => {
    try {
      const res = await GeneralSetting.getByKey({
        state: "bank",
        id: "bank",
        showErr: false,
      });
      console.log(res, "res");

      const parsed = res?.infos ?? {};
      setInitialValues({
        bankName: parsed.bankName || "",
        accountName: parsed.accountName || "",
        accountNumber: parsed.accountNumber || "",
        bankQr: res?.file || null,
      });
      setExisting(res);
    } catch (err) {
      console.error("Error fetching bank settings:", err);
    }
  };

  useEffect(() => {
    fetchBankSettings();
  }, []);

  const handleSubmit = async (values: any) => {
    console.log(values);
    setLoading(true);
    const formData = new FormData();

    try {
      formData.append("group", "payment-settings");
      formData.append("key", "bank");
      formData.append("title", "Bank Transfer");
      formData.append(
        "infos",
        JSON.stringify({
          bankName: values.bankName,
          accountName: values.accountName,
          accountNumber: values.accountNumber,
        })
      );

      if (values?.bankQr?.rawFile) {
        formData.append("file", values.bankQr.rawFile);
      }

      if (existing?.id) {
        await GeneralSetting.update({
          state: "bank",
          data: formData,
          id: existing?.id,
        }).then(() => toast.success("Bank settings updated successfully!"));
      } else {
        await GeneralSetting.create({ state: "bank", data: formData }).then(
          () => toast.success("Bank settings created successfully!")
        );
      }

      fetchBankSettings();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update bank settings");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={handleSubmit}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <CardHeader title="PhonePay & Bank" />
          <Wrapper>
            <Row styleRow="align-items:start;gap:20px">
              <div style={{ flex: 2, width: "100%" }}>
                <Column>
                  <Fields.Input
                    name="bankName"
                    label="Bank Name"
                    placeholder="Enter bank name"
                  />
                  <Fields.Input
                    name="accountName"
                    label="Bank Account Name"
                    placeholder="Enter account holder name"
                  />
                  <Fields.Input
                    name="accountNumber"
                    label="Bank Account Number"
                    placeholder="Enter account number"
                  />
                </Column>
              </div>
              <div style={{ flex: 1, width: "100%" }}>
                <Fields.Upload
                  name="bankQr"
                  useRawFile={true}
                  onChange={(file: any) => setFieldValue("bankQr", file)}
                />
              </div>
            </Row>

            <div style={{ marginTop: 16, textAlign: "right" }}>
              <Button
                title={existing?.id ? "Update" : "Save"}
                type="submit"
                loading={loading}
                justify="end"
              />
            </div>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default Bank;
